var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgCircleSlashinline = function SvgCircleSlashinline(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 18 19"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9 2.88c-3.668 0-6.62 2.94-6.62 6.542 0 3.603 2.952 6.543 6.62 6.543s6.62-2.94 6.62-6.543C15.62 5.82 12.669 2.88 9 2.88ZM0 9.421C0 4.484 4.04.5 9 .5s9 3.984 9 8.922c0 4.94-4.04 8.923-9 8.923S0 14.36 0 9.422Z",
    fill: "#A9A8A8"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "m15.938 4.437-11.25 11.25-1.857-1.856 11.25-11.25 1.857 1.856Z",
    fill: "#A9A8A8"
  })));
};
export default SvgCircleSlashinline;